"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _parameter = _interopRequireDefault(require("../common/errors/parameter"));
var MemberUtil = {};

/**
 * @param {Object} participant the locus participant
 * @returns {Boolean}
 */
MemberUtil.isUser = function (participant) {
  return participant && participant.type === _constants._USER_;
};
MemberUtil.isModerator = function (participant) {
  return participant && participant.moderator;
};

/**
 * @param {Object} participant the locus participant
 * @returns {Boolean}
 */
MemberUtil.isGuest = function (participant) {
  return participant && participant.guest;
};

/**
 * @param {Object} participant the locus participant
 * @returns {Boolean}
 */
MemberUtil.isDevice = function (participant) {
  return participant && participant.type === _constants._RESOURCE_ROOM_;
};
MemberUtil.isModeratorAssignmentProhibited = function (participant) {
  return participant && participant.moderatorAssignmentNotAllowed;
};

/**
 * checks to see if the participant id is the same as the passed id
 * there are multiple ids that can be used
 * @param {Object} participant the locus participant
 * @param {String} id
 * @returns {Boolean}
 */
MemberUtil.isSame = function (participant, id) {
  return participant && (participant.id === id || participant.person && participant.person.id === id);
};

/**
 * checks to see if the participant id is the same as the passed id for associated devices
 * there are multiple ids that can be used
 * @param {Object} participant the locus participant
 * @param {String} id
 * @returns {Boolean}
 */
MemberUtil.isAssociatedSame = function (participant, id) {
  return participant && participant.associatedUsers && participant.associatedUsers.some(function (user) {
    return user.id === id || user.person && user.person.id === id;
  });
};

/**
 * @param {Object} participant the locus participant
 * @param {Boolean} isGuest
 * @param {String} status
 * @returns {Boolean}
 */
MemberUtil.isNotAdmitted = function (participant, isGuest, status) {
  return participant && participant.guest && (participant.devices && participant.devices[0] && participant.devices[0].intent && participant.devices[0].intent.type === _constants._WAIT_ &&
  // @ts-ignore
  isGuest && status === _constants._IN_LOBBY_ ||
  // @ts-ignore
  !status === _constants._IN_MEETING_);
};

/**
 * @param {Object} participant the locus participant
 * @returns {Boolean}
 */
MemberUtil.isAudioMuted = function (participant) {
  if (!participant) {
    throw new _parameter.default('Audio could not be processed, participant is undefined.');
  }
  var mutedStatus = MemberUtil.isMuted(participant.status, _constants.AUDIO_STATUS);
  if (participant.controls && participant.controls.audio) {
    if (participant.controls.audio.muted) {
      return true;
    }
    if (mutedStatus) {
      return true;
    }
  }
  return false;
};

/**
 * @param {Object} participant the locus participant
 * @returns {Boolean}
 */
MemberUtil.isVideoMuted = function (participant) {
  if (!participant) {
    throw new _parameter.default('Video could not be processed, participant is undefined.');
  }
  return MemberUtil.isMuted(participant.status, _constants.VIDEO_STATUS);
};

/**
 * @param {Object} participant the locus participant
 * @returns {Boolean}
 */
MemberUtil.isHandRaised = function (participant) {
  var _participant$controls, _participant$controls2;
  if (!participant) {
    throw new _parameter.default('Raise hand could not be processed, participant is undefined.');
  }
  return ((_participant$controls = participant.controls) === null || _participant$controls === void 0 ? void 0 : (_participant$controls2 = _participant$controls.hand) === null || _participant$controls2 === void 0 ? void 0 : _participant$controls2.raised) || false;
};

/**
 * utility method for audio/video muted status
 * @param {String} status
 * @param {String} accessor
 * @returns {Boolean}
 */
MemberUtil.isMuted = function (status, accessor) {
  if (status) {
    if (status[accessor] === _constants._RECEIVE_ONLY_) {
      return true;
    }
    if (status[accessor] === _constants._SEND_RECEIVE_) {
      return false;
    }
  }
  return null;
};

/**
 * utility method for getting the recording member for later comparison
 * @param {Object} controls
 * @returns {String|null}
 */
MemberUtil.getRecordingMember = function (controls) {
  if (!controls) {
    return null;
  }
  if (controls.record && controls.record.recording && controls.record.meta) {
    return controls.record.meta.modifiedBy;
  }
  return null;
};

/**
 * @param {Object} participant the locus participant
 * @returns {Boolean}
 */
MemberUtil.isRecording = function (participant) {
  if (!participant) {
    throw new _parameter.default('Recording could not be processed, participant is undefined.');
  }
  if (participant.controls && participant.controls.localRecord) {
    return participant.controls.localRecord.recording;
  }
  return false;
};
MemberUtil.isRemovable = function (isSelf, isGuest, isInMeeting, type) {
  if (isGuest || isSelf) {
    return false;
  }
  if (type === _constants._CALL_) {
    return false;
  }
  if (isInMeeting) {
    return true;
  }
  return false;
};
MemberUtil.isMutable = function (isSelf, isDevice, isInMeeting, isMuted, type) {
  if (!isInMeeting) {
    return false;
  }
  if (isMuted) {
    return false;
  }
  if (type === _constants._CALL_) {
    return false;
  }
  if (isSelf || isDevice) {
    return true;
  }
  return false;
};

/**
 * @param {Object} participant the locus participant
 * @returns {String}
 */
MemberUtil.extractStatus = function (participant) {
  if (!(participant && participant.devices && participant.devices.length)) {
    return _constants._NOT_IN_MEETING_;
  }
  if (participant.state === _constants._JOINED_) {
    return _constants._IN_MEETING_;
  }
  if (participant.state === _constants._IDLE_) {
    if (participant.devices && participant.devices.length > 0) {
      var foundDevice = participant.devices.find(function (device) {
        return device.intent && (device.intent.type === _constants._WAIT_ || device.intent.type === _constants._OBSERVE_);
      });
      return foundDevice ? _constants._IN_LOBBY_ : _constants._NOT_IN_MEETING_;
    }
    return _constants._NOT_IN_MEETING_;
  }
  if (participant.state === _constants._LEFT_) {
    return _constants._NOT_IN_MEETING_;
  }
  return _constants._NOT_IN_MEETING_;
};

/**
 * @param {Object} participant the locus participant
 * @returns {String}
 */
MemberUtil.extractId = function (participant) {
  if (participant) {
    return participant.id;
  }
  return null;
};

/**
 * extracts the media status from nested participant object
 * @param {Object} participant the locus participant
 * @returns {Object}
 */
MemberUtil.extractMediaStatus = function (participant) {
  if (!participant) {
    throw new _parameter.default('Media status could not be extracted, participant is undefined.');
  }
  return {
    audio: participant.status.audioStatus,
    video: participant.status.videoStatus
  };
};

/**
 * @param {Object} participant the locus participant
 * @returns {String}
 */
MemberUtil.extractName = function (participant) {
  if (participant && participant.person) {
    return participant.person.name;
  }
  return null;
};
var _default = MemberUtil;
exports.default = _default;
//# sourceMappingURL=util.js.map
